import {
  formatDimensionValueForDisplay,
  formatWeightValueForDisplay,
} from './FormatMeasurementValueForDisplay';
import { DIMENSION_FIELDS, WEIGHT_FIELDS } from './MeasurementFields';

export type ConvertibleEntryValue =
  | string
  | number
  | boolean
  | object
  | null
  | undefined;

const isConvertibleNumber = (
  value: ConvertibleEntryValue,
): value is number | string =>
  (typeof value === 'number' || typeof value === 'string') &&
  value !== '' &&
  !isNaN(Number(value));

const convertLeaf = (
  key: string,
  value: ConvertibleEntryValue,
  isMetric: boolean,
): ConvertibleEntryValue => {
  if (!isConvertibleNumber(value)) return value;
  if (DIMENSION_FIELDS.includes(key))
    return formatDimensionValueForDisplay(value, isMetric);
  if (WEIGHT_FIELDS.includes(key))
    return formatWeightValueForDisplay(value, isMetric);
  return value;
};

const convertValue = (
  key: string,
  value: ConvertibleEntryValue,
  isMetric: boolean,
): ConvertibleEntryValue => {
  if (Array.isArray(value)) {
    return value.map((item) => convertValue(key, item, isMetric));
  }
  if (value !== null && typeof value === 'object') {
    return convertRecord(
      value as Record<string, ConvertibleEntryValue>,
      isMetric,
    );
  }
  return convertLeaf(key, value, isMetric);
};

const convertRecord = (
  record: Record<string, ConvertibleEntryValue>,
  isMetric: boolean,
): Record<string, ConvertibleEntryValue> =>
  Object.fromEntries(
    Object.entries(record).map(([key, value]) => [
      key,
      convertValue(key, value, isMetric),
    ]),
  );

export const convertEntriesToUnitSystem = <
  Entries extends Record<string, ConvertibleEntryValue>,
>(
  entries: Entries,
  isMetric: boolean,
): Entries => convertRecord(entries, isMetric) as Entries;
